import type {ReactNode} from 'react';

import {twx} from '@/utils/tailwindUtils';

export interface InlineNotificationProps {
    className?: string;
    contentClassName?: string;
    bodyClassName?: string;
    iconWrapperClassName?: string;
    title?: ReactNode;
    body?: ReactNode;
    children?: ReactNode;
    trailingNode?: ReactNode;
    trailingNodeClassName?: string;
    icon?: ReactNode;
    role?: string;
    'aria-live'?: 'polite' | 'assertive' | 'off';
}

const InlineNotification = ({
    className,
    contentClassName,
    bodyClassName,
    iconWrapperClassName,
    title,
    body,
    children,
    trailingNode,
    trailingNodeClassName,
    icon,
    role = 'alert',
    'aria-live': ariaLive = 'polite',
}: InlineNotificationProps) => (
    <div
        role={role}
        aria-live={ariaLive}
        className={twx('relative flex w-full flex-col gap-4 rounded-xl bg-primary-dark p-4', className)}
    >
        <div className='flex min-w-0 flex-1 items-center gap-2 text-start'>
            {icon && <div className={twx('p-2', iconWrapperClassName)}>{icon}</div>}
            <div className={twx('flex min-w-0 flex-1 flex-col text-romance', contentClassName)}>
                {title && <p className='m-0 font-bold text-16 leading-15'>{title}</p>}
                {body && <p className={twx('m-0 text-14 leading-143', bodyClassName)}>{body}</p>}
            </div>
            {trailingNode != null && (
                <div className={twx('ml-4 shrink-0 self-start', trailingNodeClassName)}>{trailingNode}</div>
            )}
        </div>
        {children}
    </div>
);

export default InlineNotification;
